import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCourseModule } from "../../../../service/endpoints";

export const ModuleHandler = createAsyncThunk('ModuleHandler', async (data) => {
    try {
        const response = await getCourseModule(data)
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
})




const getModuleSlice = createSlice({
    name: 'get_modules',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(ModuleHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(ModuleHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(ModuleHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        })
       
    }

});



export default getModuleSlice.reducer;
